












































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import moment from "moment";
import _ from "lodash";
import {eGameStage} from "@/common/enumData";
import Sorting from "@/components/studio/_sorting.vue";

@Component({
    components: {Sorting},
})
export default class ProjectList extends Vue {
    gameStage = eGameStage;
    inputKeyword: string = '';
    projectList: any = []
    moment = moment;
    count = 0;
    orginList: any = []

    pageSize: number = 10;
    currPage: number = 0;

    async mounted() {
        await this.$store.dispatch("loginState");
        this.fetch();
    }

    fetch() {
        this.$api.projectList()
            .then((res: any) => {
                this.projectList = _.sortBy(res, res.created_at).reverse();
                this.orginList = res;
            })
    }


    searchGame() {
        let list: any = [];
        const input = this.inputKeyword;

        if (input.length > 0) {
            this.orginList.map((e: any) => {
                    if (e.name.includes(input)) {
                        list.push(e)
                    }
                }
            );
            this.projectList = list;
        }
        else {
            this.projectList = this.orginList;
        }

    }

    editProject(id: string) {
        this.$router.push(`/${this.$i18n.locale}/project/${id}`)
    }

    sortedArray(array: any) {
        console.log('sortedArray', array)
        this.projectList = [];
        this.projectList = array;
    }

    /**
     * 페이지네이션
     */
    pagingData() {
        const start = this.currPage * this.pageSize;
        const end = start + this.pageSize;

        return this.projectList.slice(start, end);
    }

    pageCount() {
        return Math.floor((this.projectList.length - 1) / this.pageSize) + 1;
    }

    nextPage() {
        document.documentElement.scrollTop = 0;
        this.currPage += 1;
    }

    prevPage() {
        document.documentElement.scrollTop = 0;
        this.currPage -= 1;
    }
}
